import { Button } from "@habitech/call-to-action";
import { useEffect, useState } from "react";
import { basicInformation, getDisabledSummary, getMoreInfoMigrateSummary, getUserEmailContactSummary, basicInformationContact} from "src/apis/migrateSummary";
import Icon from "src/components/common/Icon";
import { DownButton } from "src/components/MigrateFeed/styles";
import { MigrateActiveFlex } from "./MigrateActive/MigrateActive.styles";
import { migrateFeedToManualApi } from "src/apis/postMigrateFeed";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectMigrateFeed, setLoadingMigration, setStatusToMigrate } from "src/redux/migrate_feed/migrateFeedSlice";
import { setPhoneError } from 'src/redux/migrate_email_contact/migrateEmailContact';
import { postMigrateEmailContact } from "src/apis/postMigrateEmailContact";
import { setSummary as setUnbanSummary, setLoading as setUnbanLoading } from 'src/redux/unban_user/slice';
import { Summary as UnbanUserResponse} from 'src/redux/unban_user/state.types';
import { CreateRowResponse } from "./useMigrateTab.types";
import { unbanUser } from "src/apis/UnbanUser/unbanUser";

export const createRow = (type, row, functions, loadingMigration): CreateRowResponse => {
    switch (type) {
        case 'disabled':
            return {
                allPropertiesCount: <MigrateActiveFlex>
                    {row.allPropertiesCount}
                    <DownButton onClick={() => functions.downloadReport(row.email, row.allProperties, 'all')}>
                        <Icon size={24} icon="pcom-icon-circle-arrow-outline-down" />
                    </DownButton>
                </MigrateActiveFlex>,
                inactivePropertiesCount: <MigrateActiveFlex>
                    {row.propertiesDisableCount}
                    <DownButton onClick={() => functions.downloadReport(row.email, row.propertiesDisable, 'inactive')}>
                        <Icon size={24} icon="pcom-icon-circle-arrow-outline-down" />
                    </DownButton>
                </MigrateActiveFlex>,
                inactivePropertiesDate: functions.formatDate(row.last_date),
                email: row.email,
                user_phone: row.user_phone,
                full_name: row.full_name,
                feed_name: row.feed_name,
                actions: (
                    <Button dataId={"migratDisabled-" + row.user_id} originType="pcom" loading={loadingMigration} onClick={
                        () => functions.handleMigrateClick(row.feed_name, row.email, row.propertiesDisable)
                    }>Migrar</Button>
                ),
            }
        case 'moreInfo':
            return {
                allPropertiesCount: <MigrateActiveFlex>
                    {row.allPropertiesCount}
                    <DownButton onClick={() => functions.downloadReport(row.email, row.allProperties, 'all')}>
                        <Icon size={24} icon="pcom-icon-circle-arrow-outline-down" />
                    </DownButton>
                </MigrateActiveFlex>,
                propertiesToMigrateCount: <MigrateActiveFlex>
                    {row.propertiesToMigrateCount}
                    <DownButton onClick={() => functions.downloadReport(row.email, row.propertiesToMigrate, 'migrate')}>
                        <Icon size={24} icon="pcom-icon-circle-arrow-outline-down" />
                    </DownButton>
                </MigrateActiveFlex>,
                email: row.email,
                user_phone: row.user_phone,
                full_name: row.full_name,
                feed_name: row.feed_name,
                more_info_date: functions.formatDate(row.more_info_date),
                actions: (
                    <Button dataId={"migrateMoreInfo-" + row.user_id} originType="pcom" loading={loadingMigration} onClick={
                        () => functions.handleMigrateClick(row.feed_name, row.email, row.propertiesToMigrate)
                    }>Migrar</Button>
                ),
            };
        case 'banned':
            return {
                email: row.email,
                feed_name: row.feed_name,
                total_rejections: row.total_rejections,
                total_publications_active: row.total_publications_active,
                date_of_last_direct_publication: row.date_of_last_direct_publication,
                actions: (
                    <Button dataId={"migratDisabled-" + row.user_id} originType="pcom" loading={loadingMigration} onClick={
                        () => functions.handleUnbann(row.email)
                    }>Desbanear</Button>
                ),
            };
        case 'default':
            return {}
    }
};


const isNumeric = (str: string): boolean => {
    return /^\d+$/.test(str);
  };

export const validatePhoneNumber = (phone: string) => {
    if (!isNumeric(phone)) {
        throw new Error('Phone number is not valid');
    }
};

export const useMigrateTab = (type, emailContact="", summaryByEmailContact=null, activeTab=1, bannedUsers=null) => {
    const [summary, setSummary] = useState({
        data: [],
    });
    const [emailContactSummary, setEmailContactSummary] = useState({
        data: [],
    });
    const [stateToMigrate, setStateToMigrate] = useState(null);
    const [loadingSummary, setLoadingSummary] = useState(false);
    const [modal, setModal] = useState({
        show: false,
        message: '',
    });
    const [shouldMigrate, setShouldMigrate] = useState(false);
    const [migrationParams, setMigrationParams] = useState({ feedName: '', email: '', PropertiesArray: '' });
    const { phone, newContactEmail } = useAppSelector((state) => state.migrate_email_contact);
    const { feedName, userId } = useAppSelector((state) => state.unbanUser);
    const dispatch = useAppDispatch();

    const token = useAppSelector((state) => state.User.token);
    const { statusToMigrate, loadingMigration, newEmail } = useAppSelector(selectMigrateFeed);

    useEffect(() => {
        getSummary();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [summaryByEmailContact, activeTab, bannedUsers]);

    useEffect(() => {
        if (stateToMigrate !== null) {
            dispatch(setStatusToMigrate(stateToMigrate));
        }
    }, [stateToMigrate, dispatch]);

    useEffect(() => {
        if (shouldMigrate) {
            if(activeTab !== 5) {
                // eslint-disable-next-line no-useless-rename
                const { feedName, email, PropertiesArray: PropertiesArray } = migrationParams;
                migrateProperties(feedName, email, PropertiesArray);
                setShouldMigrate(false);  
            } else {
                // eslint-disable-next-line no-useless-rename
                const { PropertiesArray: PropertiesArray } = migrationParams;
                migratePropertiesByEmailContact(emailContact, PropertiesArray)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldMigrate, statusToMigrate, migrationParams, activeTab]);

    const migrateProperties = async (feedName: string, email: string, PropertiesArray: string) => {
        dispatch(setLoadingMigration(true));
        const status = statusToMigrate ? statusToMigrate : 'same';

        try {
            const res = await migrateFeedToManualApi(feedName, email, newEmail, token, PropertiesArray, status);
            setModal({
                show: true,
                message: res.errors.message,
            });
            const newSummary = summary.data.filter((item) => item.email !== email);
            setSummary({
                data: newSummary,
            });
        } catch (err) {
            setModal({
                show: true,
                message: 'Error al migrar las propiedades',
            });
        } finally {
            dispatch(setLoadingMigration(false));
        }
    };

      
    const migratePropertiesByEmailContact = async (email: string, PropertiesArray: string) => {
          
        try {
            validatePhoneNumber(String(phone));
            dispatch(setPhoneError(false));
        } catch (err) {
            dispatch(setPhoneError(true));
            return;
        }        
        dispatch(setLoadingMigration(true));
        setLoadingSummary(true);
        const status = statusToMigrate ? statusToMigrate : 'same';
        try {
            const res = await postMigrateEmailContact(email, newContactEmail, phone, PropertiesArray, token, status);
            setModal({
                show: true,
                message: res.errors.message,
            });
            const newSummary = summary.data.filter((item) => item.email !== email);
            setSummary({
                data: newSummary,
            });
        } catch (err) {
            setModal({
                show: true,
                message: 'Error al migrar las propiedades',
            });
        } finally {
            dispatch(setLoadingMigration(false));
            setLoadingSummary(false);
        }  
    };

    const downloadReport = async (email: string, propertiesId: string, type: string) => {
        const basicInformationService = activeTab === 5 ? basicInformationContact : basicInformation;
        const res = await basicInformationService(propertiesId, email);
        if (res.errors.code === 200) {
            const rows = res.data;
            let csvContent = 'data:text/csv;charset=utf-8;,';
            rows.forEach((row) => {
                const csvRow = [row.id, row.city, row.colony, row.state].join(",");
                csvContent += csvRow + '\r\n';
            });
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement('a');
            link.setAttribute('href', encodedUri);
            link.setAttribute('download', `reporte-${type}.csv`);
            document.body.appendChild(link); // Required for FF
            link.click();
        }
    };

    const formatDate = (date: string) => {
        const dateObject = new Date(date);
        return dateObject.toLocaleDateString();
    };

    const getSummary = async () => {
        try {
            let res;
            if (activeTab === 5) {
                setLoadingSummary(true);

                if (summaryByEmailContact !== null) {
                    const formattedData = summaryByEmailContact.data.map((item) => createRow(type, item, { downloadReport, handleMigrateClick, formatDate }, loadingMigration))
                    setEmailContactSummary({ data: formattedData});
                } else if ( emailContact !== '') {
                    res = await getUserEmailContactSummary(emailContact)
                    const formattedData = res.data.map((item) => createRow(type, item, { downloadReport, handleMigrateClick, formatDate }, loadingMigration))
                    setEmailContactSummary({ data: formattedData });
                } 
                setLoadingSummary(false);
            } else if ([3, 4].includes(activeTab)) {
                setLoadingSummary(true);
                const getPropertiesMigrateTab = type === 'disabled' ? getDisabledSummary : getMoreInfoMigrateSummary;
                res = await getPropertiesMigrateTab();
                const formattedData = res.data.map((item) => createRow(type, item, { downloadReport, handleMigrateClick, formatDate }, loadingMigration))
                setSummary({ data: formattedData });
                setLoadingSummary(false);
            }else if (activeTab === 6) {
                const formattedData = createRow("banned", bannedUsers.data, { downloadReport, handleUnbann, formatDate }, loadingMigration) as UnbanUserResponse;		
                dispatch(setUnbanSummary(formattedData));
                bannedUsers.data = null;
            }
        } catch (err) {
            setSummary({ data: [] });
        } finally {
            setLoadingSummary(false);
        }        
    }; 

    const handleMigrateClick = (feedName: string, email: string, propertiesArray: string) => {
        setMigrationParams({ feedName, email, PropertiesArray: propertiesArray });
        setShouldMigrate(true);
    };

    const handleUnbann = async (email: string) => {
        dispatch(setUnbanLoading(true));
        try {
            const response = await unbanUser(feedName, email, userId, token);
            if (response?.success) {
                    setModal({
                    show: true,
                    message: 'Solicitud de desbaneo exitosa',
                });
                dispatch(setUnbanSummary({} as UnbanUserResponse));
            } else {
                throw new Error( 'Error al solicitar desbanear el usuario');
            }
        } catch (error) {
            setModal({
                show: true,
                message: error.message,
            });
        } finally {
            dispatch(setUnbanLoading(false));
        }
    } 

    const onCloseModal = () => {
        getSummary();
        setModal({
            show: false,
            message: '',
        });
    };

    return {
        summary,
        stateToMigrate,
        showModal: modal.show,
        modalMessage: modal.message,
        loadingMigration,
        loadingSummary,
        setStateToMigrate,
        downloadReport,
        onCloseModal,
        migrateProperties,
        createRow,
        userSummary: {
            values: {
                email: '',
            },
        },
        migratePropertiesByEmailContact,
        emailContactSummary,
        handleUnbann
    };
};
